import React from 'react';
import { View } from 'react-native';
import { connect } from 'react-redux';
import { useTheme } from '@hmsexp/component-library';
import RoomRanker from '../components/RoomRanker';
import styles from './style';

const RoomRankerContainer = (props) => {
  const { palette } = useTheme();

  return (
    <View style={[styles.container, { backgroundColor: palette.white }]}>
      <RoomRanker {...props} />
    </View>
  );
};

const mapStateToProps = state => ({
  config: state.roomRanker.config,
  isConfigLoading: state.roomRanker.isConfigLoading,
  isFetchingData: state.roomRanker.isFetchingData,
  applied_filter_values: state.filterReducer.applied_filter_values,
  applied_filters: state.filterReducer.applied_filters,
  filtersLoading: state.filterReducer.filtersLoading
});

export default connect(mapStateToProps)(RoomRankerContainer);